import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete, lightClose as _lightClose, lightOpen as _lightOpen } from '@/api/PMS/placeManage/placeManage';
import waves from '@/directive/waves'; // 水波纹指令

import add from './add';
import houseKeeper from '../houseKeeper/index';
export default {
  name: 'ComplexTable',
  components: {
    add: add,
    houseKeeper: houseKeeper
  },
  props: ['keyValue', 'showDialog'],
  directives: {
    waves: waves
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        areaId: ''
      },
      title: '',
      Id: -1,
      multipleSelection: [],
      dialogFormVisible: false,
      dialogHouseKeeperFormVisible: false,
      statusOptions: [{
        dicValue: 1,
        dicName: '正常'
      }, {
        dicValue: 2,
        dicName: '维护'
      }]
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      this.listQuery = {
        page: 1,
        limit: 20
      };
      this.total = null;
      this.getList();
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
      this.dialogHouseKeeperFormVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      this.listQuery.areaId = this.keyValue;
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleHouseKeeper: function handleHouseKeeper(Id) {
      this.Id = Id;
      this.title = '保洁人员配置';
      this.dialogHouseKeeperFormVisible = true;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.Id = -1;
      this.title = '添加';
      this.dialogFormVisible = true;
    },
    lightOpen: function lightOpen(Id) {
      var _this2 = this;

      this.$confirm('确认要开灯, 是否继续?', "提示").then(function () {
        var queryData = {
          id: Id
        };

        _lightOpen(queryData).then(function (response) {
          if (response.code == 200) {
            _this2.Alert({
              alertType: "add",
              message: '操作成功'
            });
          }
        });
      });
    },
    lightClose: function lightClose(Id) {
      var _this3 = this;

      this.$confirm("确认要关灯, 是否继续?", "提示").then(function () {
        var queryData = {
          id: Id
        };

        _lightClose(queryData).then(function (response) {
          // if(response.code==200){
          //
          // }
          if (response.code == 200) {
            _this3.Alert({
              alertType: "add",
              message: '操作成功'
            });
          }
        });
      });
    },
    // 编辑
    handleUpdate: function handleUpdate(Id) {
      this.Id = Id;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    delete: function _delete(Ids) {
      var _this4 = this;

      if (Ids.length > 0) {
        this.$confirm('你确定是要删除这些记录, 是否继续?', '提示').then(function () {
          fetchDelete(Ids).then(function (response) {
            _this4.getList();

            _this4.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(Id) {
      var Ids = [];
      Ids.push(Id);
      this.delete(Ids);
    },
    handleDeletes: function handleDeletes() {
      var Ids = [];
      this.multipleSelection.forEach(function (row) {
        Ids.push(row.id);
      });
      this.delete(Ids);
    }
  }
};